import React, { useState, useEffect, useMemo } from 'react';
import './ModulesModal.css';
import TableModule from '../../components/TableModule';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCubes, faXmark, faCheck, faSearch } from '@fortawesome/free-solid-svg-icons';
import { useCallback } from 'react';
import apiClient from "../../axios";

const ModulesModal = ({ isVisible, onClose, onAddModules, initialSelectedModules }) => {
    const [fullData, setFullData] = useState([]); // TODOS los módulos
    const [data, setData] = useState([]); // SOLO los que se muestran en tabla en ese momento
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedModules, setSelectedModules] = useState(initialSelectedModules || []); // Usar el valor inicial pasado por las props
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 10;
    const [subscriptionCounts, setSubscriptionCounts] = useState({});
    const [search, setSearch] = useState('');

    const fetchAllData = useCallback(async () => {
        try {
            setLoading(true);
            //const response = await apiClient.get(`/module_pack?productType=EXTRAS&page=${page}`);
            const response = await apiClient.get(`/module_pack/purchase?productType=EXTRAS`);
            const list = Array.isArray(response.data)
                ? response.data
                : [response.data];
            setFullData(list);
            setData(list);
            setTotalItems(list.length);
            /*if (Array.isArray(response.data)) {
                setData(response.data);
                setTotalItems(response.data.length);
            } else {
                setData([response.data]);
                setTotalItems(1);
            }*/
        } catch (error) {
            console.error("Error al obtener los datos del servicio", error);
        } finally {
            setLoading(false);
        }
    }, []);
    
    useEffect(() => {
        fetchAllData();
    }, [fetchAllData]); // Añadido 'fetchAllData' a las dependencias
    
    const handleRefresh = useCallback(() => {
        fetchAllData();
    }, [fetchAllData]);

    useEffect(() => {
        if (isVisible) {
            handleRefresh();
            setSelectedModules(initialSelectedModules ? initialSelectedModules.map(mod => mod.moduleCode) : []);
        }
    }, [handleRefresh, isVisible, initialSelectedModules]);
    useEffect(() => {
        if (initialSelectedModules) {
            const codes = initialSelectedModules.map(mod => mod.moduleCode);
            setSelectedModules(codes);

            const restoredCounts = {};
            initialSelectedModules.forEach(mod => {
                restoredCounts[mod.id] = mod.count || 0;
            });
            setSubscriptionCounts(restoredCounts);
        } else {
            setSelectedModules([]);
            setSubscriptionCounts({});
        }
    }, [initialSelectedModules]);

    const handleIncrement = (id) => {
        setSubscriptionCounts((prevCounts) => {
            const newCount = (prevCounts[id] || 0) + 1;
            return {
                ...prevCounts,
                [id]: newCount < 0 ? 0 : newCount,
            };
        });
    };

    const handleDecrement = (id) => {
        setSubscriptionCounts((prevCounts) => {
            const newCount = (prevCounts[id] || 0) - 1;
            return {
                ...prevCounts,
                [id]: newCount < 0 ? 0 : newCount,
            };
        });
    };

    const handleCheckboxChange = (moduleCode) => {
        setSelectedModules(prevSelected =>
            prevSelected.includes(moduleCode)
                ? prevSelected.filter(code => code !== moduleCode)
                : [...prevSelected, moduleCode]
        );
    };

    /*const handleSelectAll = () => {
        if (selectedModules.length === data.length) {
            setSelectedModules([]);
        } else {
            setSelectedModules(data.map(item => item.moduleCode));
        }
    };*/
    const handleSelectAll = () => {
            const pageCodes = currentPageData.map(item => item.moduleCode);
            const allSelected = pageCodes.every(code => selectedModules.includes(code));
    
            if (allSelected) {
                // Deselecciona solo los de esta página
                setSelectedModules(prev =>
                    prev.filter(code => !pageCodes.includes(code))
                );
            } else {
                // Añade los de esta página, sin duplicar
                setSelectedModules(prev => {
                    const newSelection = new Set([...prev, ...pageCodes]);
                    return Array.from(newSelection);
                });
            }
        };
    
        const currentPageData = useMemo(() => {
            const start = (currentPage - 1) * itemsPerPage;
            const end = start + itemsPerPage;
            return data.slice(start, end);
        }, [data, currentPage, itemsPerPage]);
    
        const isAllSelected = currentPageData.every(item => selectedModules.includes(item.moduleCode));

    const handleSearch = useCallback(async () => {
        try {
            setLoading(true);
            const params = new URLSearchParams();
            if (search) params.append('search', search);

            const response = await apiClient.get(`/module_pack/purchase?productType=EXTRAS&${params.toString()}`);
            const list = Array.isArray(response.data)
                ? response.data
                : [response.data];
            setData(list);
            setTotalItems(list.length);
            /*if (Array.isArray(response.data)) {
                setData(response.data);
            } else {
                setData([response.data]);
            }*/
            setTotalItems(response.data.total);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.error("Error al obtener los datos del servicio", error);
            }
        } finally {
            setLoading(false);
        }
    }, [search]);
    
    const handleFresh = async (code) => {
        handleSearch(1)
    };

    useEffect(() => {
        if (!search) {
          setData(fullData);
        }
      }, [search, fullData]);

    const handleSave = () => {
        const selectedData = fullData
            .filter(item => selectedModules.includes(item.moduleCode))
            .map((item) => {
                //const index = data.findIndex(d => d.moduleCode === item.moduleCode); // Encontrar el índice correcto
                return {
                    ...item,
                    count: subscriptionCounts[item.id] || 0,
                    productType: "EXTRAS" //agregado
                };
            });
            console.log(selectedData);
        onAddModules(selectedData, "EXTRAS"); //agregado
        onClose();
    };

    const columns = [
        { title: "Nombre", key: "description" },
        { title: "Descripción", key: "description" },
        { title: "Precio Módulo", key: "precioCompra" },
        { title: "Usuarios Extras", key: "extraSus" },
        { title: "Total", key: "precioSus" },
        { title: "Seleccionar", key: "acciones" }
    ];

    const renderRow = (item, index) => {
        const count = subscriptionCounts[item.id] || 0;
        const total = count * item.perUserPrice + item.purchasePrice;
        return (
            <>
                <td>{item.moduleName}</td>
                <td>{item.description}</td>
                <td >${item.purchasePrice.toFixed(2)}</td>
                <td>
                    {item.perUserPrice !== 0 ? (
                        <>
                            <div className="sale-counter2">
                                <button onClick={() => handleDecrement(item.id)}>-</button>
                                <span>{count}</span>
                                <button onClick={() => handleIncrement(item.id)}>+</button>
                            </div>
                            <div className="align-center">${item.perUserPrice.toFixed(2)} C/U</div>
                        </>
                    ) : (
                        <div className="align-center">-</div>
                    )}
                </td>
                <td>${total.toFixed(2)}</td>
                <td className="align-center">
                    <input
                        type="checkbox"
                        checked={selectedModules.includes(item.moduleCode)}
                        onChange={() => handleCheckboxChange(item.moduleCode)}
                    />
                </td>
            </>
        );
    };

    return (
        isVisible && (
            <div className="modal-overlay">
                <div className="modal-content-module">
                    <h3 className="modal-title ">Módulos Extras</h3>
                    <div className="modal-content-module-body">
                        <div className="search-module-container">
                            <div className="filter-form">
                                <div className="basic-info-form-group">
                                    <input
                                        type="text"
                                        id="module-pack"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        placeholder="Módulo"
                                    />
                                </div>
                                <button className="basic-custom-button" onClick={handleFresh}>
                                    <FontAwesomeIcon icon={faSearch} className="basic-shortcut-icon" />
                                    Buscar
                                </button>
                            </div>
                        </div>
                        <TableModule
                            title="Lista de Módulos"
                            rows={data}
                            columns={columns}
                            icon={faCubes}
                            renderRow={renderRow}
                            currentPage={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={setCurrentPage}
                            onRefresh={handleRefresh}
                            onSelectAll={handleSelectAll}
                            isAllSelected={isAllSelected}
                            loading={loading}
                            select={true}
                        />
                    </div>
                    <div className="modulesmodal-basic-form-footer">
                        <button
                            className="basic-custom-button-tm"
                            onClick={onClose}
                        >
                            <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                            Cancelar
                        </button>
                        <button className="basic-custom-button-tm" onClick={handleSave}>
                            <FontAwesomeIcon icon={faCheck} className="basic-shortcut-icon" />
                            Aceptar
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default ModulesModal;
